'use client'

import { HomeSocialWallFragment } from '@/components/Home/HomeSocialWall/HomeSocialWall.generated'
import { Heading } from '@desoutter/uikit'
import Script from 'next/script'

interface HomeSocialWallProps {
	fragment: HomeSocialWallFragment
}

export default function HomeSocialWall({ fragment }: HomeSocialWallProps) {
	const url = `${fragment.script}?${Date.now()}`

	return (
		<div>
			<div className="container-auto py-16">
				<div className="flex flex-col items-center dark:text-foreground">
					<Heading as="h2" className="mb-12">
						{fragment.title}
					</Heading>
				</div>
			</div>
			<div id="curator-feed-default-feed-layout">
				<a
					href="https://curator.io"
					target="_blank"
					className="crt-logo crt-tag"
				>
					Powered by Curator.io
				</a>
			</div>
			<Script src={url} strategy="afterInteractive" />
		</div>
	)
}
